import { render, staticRenderFns } from "./previewDialog.vue?vue&type=template&id=fec6b1f2&scoped=true"
import script from "./previewDialog.vue?vue&type=script&lang=js"
export * from "./previewDialog.vue?vue&type=script&lang=js"
import style0 from "./previewDialog.vue?vue&type=style&index=0&id=fec6b1f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec6b1f2",
  null
  
)

export default component.exports